import { seo } from '../seo';
export { DataProcessingAgreementPage as default } from '../../src/pages/Legal/DPA';
export const meta = () => seo('legal.dpa');
